module.exports = __webpack_public_path__ + "static/media/gh.caedb912.svg";